import React, { useState } from 'react';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // TODO: Integrate with your email service (e.g., EmailJS, Formspree, or your backend)
    console.log('Contact Form Submitted:', formData);
    
    // For now, just show success message
    setSubmitted(true);
    
    // Reset form after 3 seconds
    setTimeout(() => {
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
      setSubmitted(false);
    }, 3000);
  };

  return (
    <div className="contact">
      <div className="pricing-container">
        <h1 className="section-title">Contact Us</h1>
        <p className="section-subtitle">
          Have questions about Invex? We'd love to hear from you. Send us a message and we'll respond as soon as possible.
        </p>

        <div className="form-container">
          {submitted && (
            <div className="success-message">
              ✓ Thank you for contacting us! We'll get back to you within 24 hours.
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Full Name *</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                placeholder="Enter your full name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address *</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="your.email@example.com"
              />
            </div>

            <div className="form-group">
              <label htmlFor="phone">Phone Number</label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+966 5X XXX XXXX"
              />
            </div>

            <div className="form-group">
              <label htmlFor="company">Company Name</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                placeholder="Your business name"
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message *</label>
              <textarea
                id="message"
                name="message"
                value={formData.message}
                onChange={handleChange}
                required
                placeholder="Tell us how we can help you..."
              />
            </div>

            <button type="submit" className="btn-submit">
              Send Message
            </button>
          </form>
        </div>

        <div style={{ marginTop: '4rem', textAlign: 'center' }}>
          <h3 style={{ color: '#1a3d4d', marginBottom: '2rem' }}>Other Ways to Reach Us</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '2rem', maxWidth: '900px', margin: '0 auto' }}>
            <div style={{ padding: '2rem', background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>📧</div>
              <h4 style={{ color: '#1a3d4d', marginBottom: '0.5rem' }}>Email</h4>
              <p style={{ color: '#718096' }}>support@invexapp.com</p>
            </div>
            <div style={{ padding: '2rem', background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>📱</div>
              <h4 style={{ color: '#1a3d4d', marginBottom: '0.5rem' }}>Phone</h4>
              <p style={{ color: '#718096' }}>+966580937200</p>
              <p1 style={{ color: '#718096' }}>Sunday to Friday    9AM to 5PM</p1>
            </div>
            <div style={{ padding: '2rem', background: 'white', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>📍</div>
              <h4 style={{ color: '#1a3d4d', marginBottom: '0.5rem' }}>Location</h4>
              <p style={{ color: '#718096' }}>Saudi Arabia</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
